import { render, staticRenderFns } from "./claustro-registro.vue?vue&type=template&id=4ebb6fe2&"
import script from "./claustro-registro.component.ts?vue&type=script&lang=ts&"
export * from "./claustro-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports